export interface IDEPRECIATION_FORMULA {
  method: string;
  costAsset: number;
  salvageValue: number;
  duration: number;
  rateDepreciation: number;
}

export const DEPRECIATION_FORMULA = ({
  method,
  costAsset,
  salvageValue,
  duration,
  rateDepreciation,
}: IDEPRECIATION_FORMULA) => {
  const cost = Number(costAsset);
  const salvage = Number(salvageValue);
  const dur = Number(duration);
  const rate = Number(rateDepreciation);
  if (
    cost < 0 ||
    cost > 1e10 ||
    salvage < 0 ||
    salvage > 100 ||
    dur < 1 ||
    dur > 100 ||
    rate < 0 ||
    rate > 100
  ) {
    const res = ' ';
    return {
      outputDepreciation: res,
    };
  }
  let msg = '';
  const depYear = Math.round((cost - cost * (salvage / 100)) / dur);
  if (method == 'straight') {
    msg = `Depreciation per Year : ₹${depYear}`;
  } else if (method == 'sum') {
    const dep = Math.round(cost - cost * (salvage / 100));
    msg = `Total Depreciation : ₹${dep}`;
  } else msg = 'Check Table Below';
  return {
    depYear: depYear,
    method: method,
    cost: cost,
    salvage: salvage,
    dur: dur,
    rate: rate,
    outputDepreciation: msg,
  };
};
